import {Model} from '@vuex-orm/core';
import UnitPlanWeek from './UnitPlanWeek';
import Ie from '../objetive/Ie';

export default class UnitPlanWeekIe extends Model {
    static entity = 'unitplan_week_ies';

    static fields () {
        return {
            id: this.number(0),
            unitplanweek_id: this.number(null),
            ie_id: this.number(null),
            type: this.number(1), // 1 Clase, 2 Evaluación
            done: this.boolean(false),

            disabled: this.boolean(false),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            //
            week: this.belongsTo(UnitPlanWeek, 'unitplanweek_id'),
            ie: this.hasOne(Ie, 'id'),
        };
    }
}
